module.exports = __webpack_public_path__ + "img/demo4.7a193847.jpg";